import Config from 'services/config/config';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { GET_ASSIGNEE } from './type';

export const getAssigneeList = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.assigneeData}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: GET_ASSIGNEE, payload: data.response.data });
    return true;
  }
};

export const postAssignee = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.installation.siteAssign
  );
  if (res) {
    return true;
  } else {
    return null;
  }
};
